module.exports = __webpack_public_path__ + "img/logo.45704b6e.svg";